import { Divider, Paper, Stack, Typography } from '@mui/material';
import PipelineTable from './PipelineTable/PipelineTable';
import { Trans } from 'react-i18next';

const PipelineOverview = (): JSX.Element => {
  return (
    <Paper elevation={2} sx={{ px: 2, py: 2 }}>
      <Stack direction={'column'} spacing={1}>
        <Typography variant={'h4'}>
          <Trans>Pipelines</Trans>
        </Typography>
        <Divider />
        <PipelineTable />
      </Stack>
    </Paper>
  );
};

export default PipelineOverview;
